var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomelogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 988.838,
    height: 412.07,
    viewBox: "0 0 988.838 412.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        opacity: 0.12;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #ff8200;\r\n      }\r\n\r\n      .cls-3 {\r\n        filter: url(#Trazado_14);\r\n      }\r\n\r\n      .cls-4 {\r\n        filter: url(#Trazado_13);\r\n      }\r\n\r\n      .cls-5 {\r\n        filter: url(#Trazado_12);\r\n      }\r\n\r\n      .cls-6 {\r\n        filter: url(#Trazado_11);\r\n      }\r\n\r\n      .cls-7 {\r\n        filter: url(#Trazado_10);\r\n      }\r\n\r\n      .cls-8 {\r\n        filter: url(#Trazado_9);\r\n      }\r\n\r\n      .cls-9 {\r\n        filter: url(#Trazado_8);\r\n      }\r\n\r\n      .cls-10 {\r\n        filter: url(#Trazado_7);\r\n      }\r\n\r\n      .cls-11 {\r\n        filter: url(#Trazado_6);\r\n      }\r\n\r\n      .cls-12 {\r\n        filter: url(#Trazado_5);\r\n      }\r\n\r\n      .cls-13 {\r\n        filter: url(#Trazado_4);\r\n      }\r\n\r\n      .cls-14 {\r\n        filter: url(#Trazado_3);\r\n      }\r\n\r\n      .cls-15 {\r\n        filter: url(#Trazado_2);\r\n      }\r\n\r\n      .cls-16 {\r\n        filter: url(#Trazado_1);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_1",
    x: 213.563,
    y: 268.243,
    width: 76.651,
    height: 60.398,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_2",
    x: 270.214,
    y: 268.243,
    width: 77.005,
    height: 61.046,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_3",
    x: 326.337,
    y: 268.243,
    width: 40.139,
    height: 60.398,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_4",
    x: 346.123,
    y: 268.243,
    width: 65.522,
    height: 60.398,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_5",
    x: 392.881,
    y: 268.243,
    width: 74.943,
    height: 60.398,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_6",
    x: 469.439,
    y: 268.243,
    width: 80.478,
    height: 60.398,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_7",
    x: 530.566,
    y: 268.243,
    width: 77.004,
    height: 61.046,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_8",
    x: 586.393,
    y: 268.243,
    width: 79.242,
    height: 60.398,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_9",
    x: 647.345,
    y: 268.243,
    width: 76.651,
    height: 60.398,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_10",
    x: 701.877,
    y: 268.243,
    width: 73.589,
    height: 60.398,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_11",
    x: 489.247,
    y: 82.883,
    width: 234.68,
    height: 182.343,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_12",
    x: 483.461,
    y: 202.745,
    width: 69.696,
    height: 62.481,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_13",
    x: 256.28,
    y: 82.883,
    width: 233.713,
    height: 182.343,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_14",
    x: 333.245,
    y: 143.416,
    width: 65.407,
    height: 56.935,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home_Logo",
    transform: "translate(-841.616 -25.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    className: "cls-1",
    transform: "translate(841.616 25.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1-2",
    "data-name": "Trazado 1",
    className: "cls-2",
    d: "M156.3,981.133h46.078l-7.967,45H144.994a46.323,46.323,0,0,1-15.342-2.423,35.792,35.792,0,0,1-11.843-6.674,29.5,29.5,0,0,1-10.281-22.663,33.846,33.846,0,0,1,3.983-16.256,40.314,40.314,0,0,1,10.766-12.758,50.841,50.841,0,0,1,15.934-8.288A62.9,62.9,0,0,1,157.7,954.11h51.569L191.5,972.843H154.36a29.291,29.291,0,0,0-9.421,1.507,25.091,25.091,0,0,0-7.8,4.2,20.978,20.978,0,0,0-5.329,6.352,16.388,16.388,0,0,0-1.992,7.967,13.032,13.032,0,0,0,5.005,10.766q5.008,3.984,13.4,3.983h27.345l1.83-10.443H140.042Z",
    transform: "translate(-107.529 -615.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2-2",
    "data-name": "Trazado 2",
    className: "cls-2",
    d: "M294.088,994.7q-5.814,32.621-50.6,32.621-23.149,0-33.858-6.46t-10.713-19.378a37.956,37.956,0,0,1,.646-6.783l7.213-40.587h22.285L221.742,994.7a28.591,28.591,0,0,0-.323,3.983,8.915,8.915,0,0,0,1.184,4.737,8.188,8.188,0,0,0,4.091,3.122,29.761,29.761,0,0,0,7.751,1.724,114.649,114.649,0,0,0,12.273.537,67.142,67.142,0,0,0,10.928-.753,21.411,21.411,0,0,0,7.374-2.475,12.266,12.266,0,0,0,4.468-4.415,19.3,19.3,0,0,0,2.206-6.46l7.213-40.587H301.3Z",
    transform: "translate(-95.352 -615.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3-2",
    "data-name": "Trazado 3",
    className: "cls-2",
    d: "M311.738,1026.134H289.453l12.811-72.024h22.178Z",
    transform: "translate(-83.288 -615.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4-2",
    "data-name": "Trazado 4",
    className: "cls-2",
    d: "M402.762,1007.617,385,1026.134H321.371l12.812-72.024H356.36l-9.473,53.506Z",
    transform: "translate(-79.035 -615.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5-2",
    "data-name": "Trazado 5",
    className: "cls-2",
    d: "M495.415,984.685a34.287,34.287,0,0,1-3.981,16.256,42.271,42.271,0,0,1-10.875,13.134,53.367,53.367,0,0,1-16.041,8.828,58.129,58.129,0,0,1-19.486,3.23H396.8l7.967-44.893h22.285l-4.63,26.376h25.838a32.05,32.05,0,0,0,9.635-1.4,23.967,23.967,0,0,0,7.751-3.983,19.611,19.611,0,0,0,5.221-6.191,16.433,16.433,0,0,0,1.939-7.912,13.993,13.993,0,0,0-1.345-6.137,14.568,14.568,0,0,0-3.768-4.845,17.452,17.452,0,0,0-5.815-3.175,23.551,23.551,0,0,0-7.482-1.131H406.167l17.548-18.733h34.02a49.717,49.717,0,0,1,15.448,2.261,36.465,36.465,0,0,1,11.9,6.3,27.588,27.588,0,0,1,10.334,22.017Z",
    transform: "translate(-68.984 -615.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6-2",
    "data-name": "Trazado 6",
    className: "cls-2",
    d: "M598.89,982.855q11.732,0,17.817,4.145t6.083,12.219a29.282,29.282,0,0,1-1.938,10.766,21.27,21.27,0,0,1-6.19,8.56,29.868,29.868,0,0,1-10.982,5.6,57.987,57.987,0,0,1-16.31,1.992H520.3l17.547-18.517h54.583q4.522,0,6.567-1.507a5.372,5.372,0,0,0,2.045-4.629q0-4.3-6.782-4.307H554.967q-12.273,0-17.98-4.737a15.543,15.543,0,0,1-5.706-12.6,26.348,26.348,0,0,1,1.938-10.173,20.882,20.882,0,0,1,6.191-8.183,30.312,30.312,0,0,1,10.928-5.437,58.5,58.5,0,0,1,16.148-1.938h62.55l-17.656,18.733H561.426q-4.521,0-6.567,1.346t-2.047,4.576q0,4.092,6.89,4.091Z",
    transform: "translate(-52.528 -615.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7-2",
    "data-name": "Trazado 7",
    className: "cls-2",
    d: "M714.079,994.7q-5.814,32.621-50.6,32.621-23.151,0-33.859-6.46T618.91,1001.48a37.935,37.935,0,0,1,.645-6.783l7.214-40.587h22.285l-7.32,40.587a28.733,28.733,0,0,0-.323,3.983,8.916,8.916,0,0,0,1.185,4.737,8.189,8.189,0,0,0,4.091,3.122,29.766,29.766,0,0,0,7.751,1.724,114.658,114.658,0,0,0,12.273.537,67.14,67.14,0,0,0,10.928-.753,21.42,21.42,0,0,0,7.376-2.475,12.261,12.261,0,0,0,4.467-4.415,19.308,19.308,0,0,0,2.207-6.46L698.9,954.11h22.392Z",
    transform: "translate(-39.388 -615.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8-2",
    "data-name": "Trazado 8",
    className: "cls-2",
    d: "M811.351,1026.134H781.53l-12.7-19.055H734.592l-3.339,19.055H708.968l6.459-36.819h62.657a21.481,21.481,0,0,0,5.329-.646,15.388,15.388,0,0,0,4.414-1.83,9.51,9.51,0,0,0,3.014-2.96,7.175,7.175,0,0,0,1.13-3.93,5.839,5.839,0,0,0-2.907-5.329q-2.907-1.779-8.074-1.777H718.334l17.871-18.733H782.5a70.463,70.463,0,0,1,11.466.969,34.816,34.816,0,0,1,10.657,3.5,22.22,22.22,0,0,1,7.806,6.728,17.831,17.831,0,0,1,3.015,10.659,25.99,25.99,0,0,1-1.668,9.258,26.369,26.369,0,0,1-4.737,7.967,28.258,28.258,0,0,1-7.375,6.029,29.866,29.866,0,0,1-9.473,3.445q1.5,1.4,3.391,3.553t4.9,5.921Z",
    transform: "translate(-27.388 -615.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9-2",
    "data-name": "Trazado 9",
    className: "cls-2",
    d: "M856.064,981.133h46.078l-7.967,45H844.76a46.317,46.317,0,0,1-15.342-2.423,35.786,35.786,0,0,1-11.843-6.674,29.491,29.491,0,0,1-10.282-22.663,33.837,33.837,0,0,1,3.984-16.256,40.319,40.319,0,0,1,10.766-12.758,50.828,50.828,0,0,1,15.933-8.288,62.894,62.894,0,0,1,19.486-2.962h51.569l-17.764,18.733H854.126a29.282,29.282,0,0,0-9.421,1.507,25.1,25.1,0,0,0-7.806,4.2,21,21,0,0,0-5.329,6.352,16.389,16.389,0,0,0-1.992,7.967,13.034,13.034,0,0,0,5.007,10.766q5.006,3.984,13.4,3.983h27.344l1.832-10.443H839.808Z",
    transform: "translate(-14.287 -615.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10-2",
    "data-name": "Trazado 10",
    className: "cls-2",
    d: "M982.252,1007.617,964.6,1026.134H895.264l12.812-72.024H991.4l-17.765,18.733H927.022l-1.507,8.613h56.951l-15.5,16.364H922.609l-1.724,9.8Z",
    transform: "translate(-2.565 -615.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11-2",
    "data-name": "Trazado 11",
    className: "cls-2",
    d: "M914.671,792.87q-28.226-20.06-82.449-20.063H671.737q-15.868,0-23.586-4.628t-7.716-16.093q0-11.455,7.716-15.872,7.709-4.4,23.586-4.409H876.31l58.638-76.712H678.792q-33.515,0-57.534,6.612-24.038,6.614-39.24,18.518A72.605,72.605,0,0,0,559.535,709.1a94.713,94.713,0,0,0-7.279,37.7,88.007,88.007,0,0,0,6.617,34.607,67.622,67.622,0,0,0,20.282,26.677q13.659,11.027,34.386,17.195t49.38,6.174H823.406q16.3,0,23.807,4.849t7.5,16.311q0,11.469-7.5,16.534t-23.807,5.072H661.085l-58.638,75.832h213.9q33.5,0,57.536-6.612t39.462-18.958a71.809,71.809,0,0,0,22.485-30.424q7.05-18.07,7.057-40.559Q942.889,812.934,914.671,792.87Z",
    transform: "translate(-48.27 -655.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12-2",
    "data-name": "Trazado 12",
    className: "cls-2",
    d: "M631.945,848.45H601.56l-58.638,75.833h30.385Z",
    transform: "translate(-49.514 -629.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13-2",
    "data-name": "Trazado 13",
    className: "cls-2",
    d: "M377.91,831.449h87.75v42.765H354.123a113.948,113.948,0,0,1-34.835-5.072,86.058,86.058,0,0,1-27.556-14.327,63.378,63.378,0,0,1-24.474-51.146,62.85,62.85,0,0,1,6.617-28.88,71.332,71.332,0,0,1,18.3-22.706A84.4,84.4,0,0,1,319.732,737.1a108.156,108.156,0,0,1,34.391-5.293h152.1l59.082-76.712H354.123q-38.37,0-70.983,10.36-32.646,10.36-56.218,29.541a139.4,139.4,0,0,0-37.034,45.853Q176.433,767.522,176.44,799.7a134.292,134.292,0,0,0,13.447,59.739,145.768,145.768,0,0,0,37.034,47.616q23.577,20.069,56.218,31.526,32.617,11.469,70.983,11.462H523.986l32.5-42.03V765.755H428.708Z",
    transform: "translate(-98.347 -655.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14-2",
    "data-name": "Trazado 14",
    className: "cls-2",
    d: "M351.4,752.743l-50.8,65.694h30.385l50.8-65.694Z",
    transform: "translate(-81.803 -642.08)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(1065.679 119.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1-2",
    "data-name": "Grupo 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1-3",
    "data-name": "Trazado 1",
    className: "cls-2",
    d: "M134.206,968.892h25.205l-4.358,24.616H128.023a25.338,25.338,0,0,1-8.392-1.326,19.57,19.57,0,0,1-6.478-3.65,16.135,16.135,0,0,1-5.624-12.4,18.513,18.513,0,0,1,2.179-8.892,22.06,22.06,0,0,1,5.889-6.979,27.83,27.83,0,0,1,8.716-4.534,34.412,34.412,0,0,1,10.659-1.62H163.18l-9.717,10.247H133.146a16.014,16.014,0,0,0-5.153.825,13.724,13.724,0,0,0-4.269,2.3,11.472,11.472,0,0,0-2.915,3.475,8.965,8.965,0,0,0-1.09,4.358,7.128,7.128,0,0,0,2.738,5.889,11.442,11.442,0,0,0,7.332,2.179h14.958l1-5.712H125.314Z",
    transform: "translate(116.53 -675.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2-3",
    "data-name": "Trazado 2",
    className: "cls-2",
    d: "M250.977,976.312q-3.18,17.844-27.678,17.844-12.663,0-18.521-3.534a11.579,11.579,0,0,1-5.86-10.6,20.762,20.762,0,0,1,.353-3.71l3.946-22.2h12.19l-4,22.2a15.661,15.661,0,0,0-.177,2.179,4.877,4.877,0,0,0,.648,2.591,4.478,4.478,0,0,0,2.238,1.708,16.289,16.289,0,0,0,4.24.943,62.725,62.725,0,0,0,6.713.294,36.729,36.729,0,0,0,5.978-.412,11.711,11.711,0,0,0,4.034-1.354,6.709,6.709,0,0,0,2.444-2.415,10.557,10.557,0,0,0,1.207-3.534l3.946-22.2h12.249Z",
    transform: "translate(81.8 -675.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3-3",
    "data-name": "Trazado 3",
    className: "cls-2",
    d: "M301.643,993.508h-12.19l7.008-39.4h12.131Z",
    transform: "translate(47.38 -675.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4-3",
    "data-name": "Trazado 4",
    className: "cls-2",
    d: "M365.893,983.379l-9.717,10.129h-34.8l7.009-39.4H340.51l-5.182,29.269Z",
    transform: "translate(35.25 -675.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5-3",
    "data-name": "Trazado 5",
    className: "cls-2",
    d: "M450.744,970.835a18.754,18.754,0,0,1-2.178,8.892,23.126,23.126,0,0,1-5.948,7.185,29.2,29.2,0,0,1-8.775,4.829,31.8,31.8,0,0,1-10.659,1.767H396.8l4.358-24.557h12.19l-2.532,14.428h14.134a17.536,17.536,0,0,0,5.27-.766,13.12,13.12,0,0,0,4.24-2.179,10.725,10.725,0,0,0,2.856-3.386,8.989,8.989,0,0,0,1.061-4.328,7.654,7.654,0,0,0-.736-3.357,7.963,7.963,0,0,0-2.061-2.65,9.552,9.552,0,0,0-3.181-1.737,12.888,12.888,0,0,0-4.092-.619H401.924l9.6-10.247h18.609a27.2,27.2,0,0,1,8.45,1.237,19.95,19.95,0,0,1,6.508,3.445,15.09,15.09,0,0,1,5.653,12.043Z",
    transform: "translate(6.58 -675.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6-3",
    "data-name": "Trazado 6",
    className: "cls-2",
    d: "M563.29,969.834q6.418,0,9.746,2.267a7.567,7.567,0,0,1,3.328,6.684,16.02,16.02,0,0,1-1.06,5.889,11.637,11.637,0,0,1-3.386,4.682,16.336,16.336,0,0,1-6.007,3.061,31.721,31.721,0,0,1-8.922,1.09H520.3l9.6-10.129h29.858a6.131,6.131,0,0,0,3.592-.824,2.938,2.938,0,0,0,1.119-2.532q0-2.354-3.71-2.356H539.264q-6.713,0-9.835-2.591a8.5,8.5,0,0,1-3.121-6.89,14.413,14.413,0,0,1,1.06-5.565,11.427,11.427,0,0,1,3.386-4.476,16.579,16.579,0,0,1,5.978-2.974,32,32,0,0,1,8.833-1.06h34.215l-9.658,10.247H542.8a6.731,6.731,0,0,0-3.592.736,2.771,2.771,0,0,0-1.119,2.5q0,2.238,3.769,2.238Z",
    transform: "translate(-40.36 -675.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7-3",
    "data-name": "Trazado 7",
    className: "cls-2",
    d: "M670.969,976.312q-3.18,17.844-27.678,17.844-12.664,0-18.521-3.534a11.579,11.579,0,0,1-5.859-10.6,20.746,20.746,0,0,1,.353-3.71l3.946-22.2H635.4l-4,22.2a15.724,15.724,0,0,0-.177,2.179,4.88,4.88,0,0,0,.648,2.591,4.481,4.481,0,0,0,2.238,1.708,16.293,16.293,0,0,0,4.24.943,62.734,62.734,0,0,0,6.713.294,36.726,36.726,0,0,0,5.978-.412,11.713,11.713,0,0,0,4.035-1.354,6.7,6.7,0,0,0,2.443-2.415,10.566,10.566,0,0,0,1.207-3.534l3.946-22.2h12.249Z",
    transform: "translate(-77.84 -675.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8-3",
    "data-name": "Trazado 8",
    className: "cls-2",
    d: "M764.972,993.508H748.66l-6.949-10.424H722.985l-1.826,10.424H708.968l3.534-20.141h34.274a11.747,11.747,0,0,0,2.915-.353,8.425,8.425,0,0,0,2.414-1,5.205,5.205,0,0,0,1.649-1.619,3.925,3.925,0,0,0,.618-2.15,3.194,3.194,0,0,0-1.59-2.915,8.464,8.464,0,0,0-4.417-.972H714.091l9.776-10.247H749.19a38.548,38.548,0,0,1,6.272.53,19.046,19.046,0,0,1,5.83,1.914,12.157,12.157,0,0,1,4.27,3.68,9.752,9.752,0,0,1,1.649,5.831,14.213,14.213,0,0,1-.912,5.064,14.422,14.422,0,0,1-2.591,4.358,15.459,15.459,0,0,1-4.034,3.3,16.354,16.354,0,0,1-5.182,1.884q.823.766,1.855,1.943t2.679,3.239Z",
    transform: "translate(-112.08 -675.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9-3",
    "data-name": "Trazado 9",
    className: "cls-2",
    d: "M833.972,968.892h25.2l-4.358,24.616h-27.03a25.335,25.335,0,0,1-8.392-1.326,19.567,19.567,0,0,1-6.478-3.65,16.129,16.129,0,0,1-5.624-12.4,18.507,18.507,0,0,1,2.179-8.892,22.06,22.06,0,0,1,5.889-6.979,27.822,27.822,0,0,1,8.716-4.534,34.41,34.41,0,0,1,10.659-1.62h28.208l-9.717,10.247H832.912a16.006,16.006,0,0,0-5.153.825,13.728,13.728,0,0,0-4.27,2.3,11.476,11.476,0,0,0-2.915,3.475,8.965,8.965,0,0,0-1.09,4.358,7.13,7.13,0,0,0,2.739,5.889,11.442,11.442,0,0,0,7.332,2.179h14.957l1-5.712H825.079Z",
    transform: "translate(-149.45 -675.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10-3",
    "data-name": "Trazado 10",
    className: "cls-2",
    d: "M942.847,983.379l-9.658,10.129H895.264l7.008-39.4h45.581l-9.717,10.247h-25.5l-.824,4.711h31.153l-8.48,8.951H910.222l-.943,5.359Z",
    transform: "translate(-182.89 -675.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11-3",
    "data-name": "Trazado 11",
    className: "cls-2",
    d: "M750.5,730.458q-15.441-10.973-45.1-10.975H617.613q-8.68,0-12.9-2.531t-4.221-8.8q0-6.267,4.221-8.682t12.9-2.412h111.9l32.075-41.962H621.472q-18.333,0-31.472,3.617t-21.464,10.13a39.715,39.715,0,0,0-12.3,15.795,51.806,51.806,0,0,0-3.981,20.621,48.142,48.142,0,0,0,3.62,18.93,36.989,36.989,0,0,0,11.094,14.592,54.229,54.229,0,0,0,18.81,9.406q11.335,3.381,27.011,3.377h87.787q8.917,0,13.023,2.653t4.1,8.922q0,6.273-4.1,9.044t-13.023,2.774H611.787l-32.075,41.48H696.717q18.326,0,31.473-3.617t21.586-10.37a39.28,39.28,0,0,0,12.3-16.642,60.628,60.628,0,0,0,3.86-22.186Q765.936,741.433,750.5,730.458Z",
    transform: "translate(-52.51 -561.71)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12-3",
    "data-name": "Trazado 12",
    className: "cls-2",
    d: "M591.618,848.45H575l-32.075,41.481h16.621Z",
    transform: "translate(-48.96 -635.21)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13-3",
    "data-name": "Trazado 13",
    className: "cls-2",
    d: "M286.646,751.561h48v23.393H273.634a62.32,62.32,0,0,1-19.055-2.774,47.076,47.076,0,0,1-15.073-7.836,34.668,34.668,0,0,1-13.387-27.977,34.381,34.381,0,0,1,3.62-15.8,39.021,39.021,0,0,1,10.011-12.42,46.166,46.166,0,0,1,15.073-8.2,59.156,59.156,0,0,1,18.812-2.9h83.2l32.318-41.962H273.634a127.723,127.723,0,0,0-38.828,5.667,92.431,92.431,0,0,0-30.752,16.16A76.249,76.249,0,0,0,183.8,702a70.464,70.464,0,0,0-7.356,32.2,73.461,73.461,0,0,0,7.356,32.678,79.734,79.734,0,0,0,20.258,26.046,95.888,95.888,0,0,0,30.752,17.245,116.287,116.287,0,0,0,38.828,6.269H366.55l17.777-22.99V715.626h-69.9Z",
    transform: "translate(90.34 -561.71)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "matrix(1, 0, 0, 1, -224.06, -93.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14-3",
    "data-name": "Trazado 14",
    className: "cls-2",
    d: "M328.384,752.743,300.6,788.678h16.621L345,752.743Z",
    transform: "translate(43.15 -598.83)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomelogo);
export default __webpack_public_path__ + "static/media/homelogo.b574b3f4fd9063fe88dbe2d54cb3f679.svg";
export { ForwardRef as ReactComponent };